export default __webpack_public_path__ + "static/media/dos-02@2x.a0445181.jpg";